import { render } from "./AccountIssues.vue?vue&type=template&id=4d391b56"
import script from "./AccountIssues.vue?vue&type=script&lang=js"
export * from "./AccountIssues.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__